document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-header]');

  var toggleHeaderState = function () {
    if (!header) {
      return;
    }

    if (window.scrollY > 20) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  var initPostPatchSliders = function () {
    var sliders = document.querySelectorAll('[data-post-patch-slider]');

    if (!sliders.length) {
      return;
    }

    sliders.forEach(function (slider) {
      var track = slider.querySelector('[data-slider-track]');
      var slides = slider.querySelectorAll('.post-patch-slide');
      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');

      if (!track || !slides.length) {
        if (prev) {
          prev.setAttribute('disabled', 'disabled');
        }

        if (next) {
          next.setAttribute('disabled', 'disabled');
        }

        return;
      }

      var slideCount = slides.length;
      var currentIndex = 0;
      var perView = 1;
      var maxIndex = 0;

      var calculatePerView = function () {
        var desired = 1.5;

        if (window.matchMedia('(min-width: 1024px)').matches) {
          desired = 2.5;
        }

        return Math.min(desired, slideCount) || 1;
      };

      var updateLayout = function () {
        perView = calculatePerView();
        slider.style.setProperty('--slides-per-view', perView);
        maxIndex = Math.max(0, Math.ceil(slideCount - perView));
        currentIndex = Math.min(currentIndex, maxIndex);
      };

      var updateControls = function () {
        var disableNavigation = slideCount <= perView;

        if (prev) {
          if (disableNavigation) {
            prev.setAttribute('disabled', 'disabled');
          } else {
            prev.removeAttribute('disabled');
          }
        }

        if (next) {
          if (disableNavigation) {
            next.setAttribute('disabled', 'disabled');
          } else {
            next.removeAttribute('disabled');
          }
        }
      };

      var goTo = function (index) {
        var wrappedIndex = index;
        var epsilon = 0.0001;

        if (slideCount > perView) {
          if (index > maxIndex + epsilon) {
            wrappedIndex = 0;
          } else if (index < -epsilon) {
            wrappedIndex = maxIndex;
          }
        }

        currentIndex = Math.min(Math.max(wrappedIndex, 0), maxIndex);
        var offset = (100 / (perView || 1)) * currentIndex;
        track.style.transform = 'translateX(-' + offset + '%)';
        updateControls();
      };

      updateLayout();
      goTo(0);

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(currentIndex - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          goTo(currentIndex + 1);
        });
      }

      var handleResize = function () {
        var previousPerView = perView;
        updateLayout();

        if (previousPerView !== perView) {
          track.style.transition = 'none';
          goTo(currentIndex);
          requestAnimationFrame(function () {
            track.style.transition = '';
          });
        } else {
          goTo(currentIndex);
        }
      };

      window.addEventListener('resize', handleResize);
    });
  };

  var initSystemIncludeAccordions = function () {
    var accordions = document.querySelectorAll('[data-system-include]');

    if (!accordions.length) {
      return;
    }

    accordions.forEach(function (wrapper) {
      var toggle = wrapper.querySelector('[data-accordion-toggle]');
      var panel = wrapper.querySelector('[data-accordion-panel]');
      var symbol = toggle ? toggle.querySelector('[data-toggle-symbol]') : null;
      var minusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57" fill="none"><rect width="57" height="57" fill="#222222"/><rect x="12" y="27" width="33" height="3" fill="#E9E9E9"/></svg>';
      var plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57" fill="none"><rect width="57" height="57" fill="#222222"/><rect x="12" y="27" width="33" height="3" fill="#E9E9E9"/><rect x="30" y="12" width="33" height="3" transform="rotate(90 30 12)" fill="#E9E9E9"/></svg>';

      var updateSymbol = function (isExpanded) {
        if (!symbol) {
          return;
        }

        symbol.innerHTML = isExpanded ? minusIcon : plusIcon;
      };

      if (!toggle || !panel) {
        return;
      }

      var setExpanded = function (open) {
        toggle.setAttribute('aria-expanded', open.toString());
        wrapper.classList.toggle('is-open', open);
        updateSymbol(open);

        if (!panel) return;

        panel.style.overflow = 'hidden';

        if (open) {
          panel.hidden = false;
          panel.style.height = 'auto';
          var fullHeight = panel.scrollHeight;
          panel.style.height = '0px';
          // force reflow so height reset sticks before animating
          void panel.offsetHeight;
          requestAnimationFrame(function () {
            panel.style.height = fullHeight + 'px';
          });
          var onExpandEnd = function (e) {
            if (e.propertyName !== 'height') return;
            panel.style.height = '';
            panel.removeEventListener('transitionend', onExpandEnd);
          };
          panel.addEventListener('transitionend', onExpandEnd);
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.height = '0px';
          });
          var onCollapseEnd = function (e) {
            if (e.propertyName !== 'height') return;
            panel.hidden = true;
            panel.style.height = '';
            panel.removeEventListener('transitionend', onCollapseEnd);
          };
          panel.addEventListener('transitionend', onCollapseEnd);
        }
      };

      toggle.addEventListener('click', function () {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        setExpanded(!isExpanded);
      });
      var initiallyExpanded = toggle.getAttribute('aria-expanded') === 'true';
      if (!initiallyExpanded && panel) {
        panel.hidden = true;
        panel.style.height = '0px';
      }
      updateSymbol(initiallyExpanded);
    });
  };

  toggleHeaderState();
  window.addEventListener('scroll', toggleHeaderState, { passive: true });
  initPostPatchSliders();
  initSystemIncludeAccordions();

  var initTechDataTabs = function () {
    var containers = document.querySelectorAll('[data-tech-data-content]');

    if (!containers.length) return;

    containers.forEach(function (container) {
      var navLinks = container.querySelectorAll('[data-tech-nav]');
      var sections = container.querySelectorAll('[data-tech-section]');

      if (!navLinks.length || !sections.length) {
        return;
      }

      var setActive = function (targetId) {
        sections.forEach(function (section) {
          var isMatch = section.id === targetId;
          section.classList.toggle('is-active', isMatch);
        });

        navLinks.forEach(function (link) {
          var isMatch = link.getAttribute('data-tech-nav') === targetId;
          var item = link.closest('.tech-data__nav-item');
          if (item) {
            item.classList.toggle('is-active', isMatch);
          }
          if (isMatch) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      };

      var firstTarget = navLinks[0].getAttribute('data-tech-nav');
      if (firstTarget) {
        setActive(firstTarget);
      }

      navLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          var targetId = link.getAttribute('data-tech-nav');
          if (targetId) {
            setActive(targetId);
          }
        });
      });
    });
  };

  initTechDataTabs();
});
